import { ErrorBoundary } from 'react-error-boundary';
import { Outlet, useNavigation } from 'react-router-dom';
import HeaderControl from '../../features/alumni/_common/HeaderControl';
import PageFooterControl from '../../library/SimpleControls/PageFooterControl';
import MenuBuilder from '../../routes/MenuBuilder';
import ErrorPage from '../../library/SimpleControls/ErrorPage';
import FactLoader from '../../library/SimpleControls/FactLoader';

function ManagementLayout() {
    const handleNavigateToHome = () => {
        return <ErrorPage />;
    };

    const navigation = useNavigation();

    return (
        <>
            <header>
                <HeaderControl />
                <MenuBuilder />
            </header>
            <FactLoader show={navigation.state === 'loading'} />
            <ErrorBoundary fallbackRender={handleNavigateToHome} onReset={(details) => {}}>
                <Outlet />
            </ErrorBoundary>
            <PageFooterControl />
        </>
    );
}

export default ManagementLayout;
